<template>
<v-container grid-list-md fluid>
  <v-layout row wrap justify-center="" class="mb-3">
    <!-- Container Card for CRUD table -->
    <v-card>
      <v-card-title class="primary white--text">
        <!-- To Factory Button and Dialog -->
        <v-dialog v-model="toFactory" persistent max-width="600px">
          <template v-slot:activator="{ on }">
            <v-btn class="success mb-2 mx-1" v-on="on">To Factory</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">To Factory</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <h3>Enter Delivery Date</h3>
                  <v-flex xs12>
                    <v-date-picker v-model="deliverydate" first-day-of-week=1 show-week=true width="350" class="pa-0">
                    </v-date-picker>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="error" flat @click="toFactory = false">Close</v-btn>
              <v-btn class="success" flat @click="start">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Add Invoice Number button and dialog -->
        <v-dialog v-model="toInvoice" max-width="600px">
          <template v-slot:activator="{ on }">
            <v-btn class="success mb-2 mx-1" v-on="on">Add Invoice Number</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Set an Invoice Number</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field autofocus label="Invoice Number: " v-model="info" prepend-icon="create"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="toInvoice = false">Close</v-btn>
              <v-btn color="blue darken-1" flat @click="addInvoice">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Add Delivery Number button and dialog -->
        <v-dialog v-model="toDeliver" max-width="600px">
          <template v-slot:activator="{ on }">
            <v-btn class="success mb-2 mx-1" v-on="on">Add Delivery Number</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Set a Delivery Number</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field autofocus label="Delivery Number: " v-model="info" prepend-icon="create"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="toDeliver = false">Close</v-btn>
              <v-btn color="blue darken-1" flat @click="addDeliveryNum">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Change Product button and dialog -->
        <v-dialog v-model="changeProd" max-width="600px">
          <template v-slot:activator="{ on }">
            <v-btn class="success mb-2 mx-1" v-on="on">Change product</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Set a product type</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-select v-model="editedItem.product" :items="items" :rules="[v => !!v || 'Product type is required']" prepend-icon="whatshot" label="Select products" required dense chips></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="changeProd = false">Close</v-btn>
              <v-btn color="blue darken-1" flat @click="changeProduct">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Add Schedule Ref button and dialog -->
        <v-dialog v-model="toSref" max-width="600px">
          <template v-slot:activator="{ on }">
            <v-btn class="success mb-2 mx-1" v-on="on">Add Schedule Ref</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Set a Schedule Ref</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field autofocus label="Schedule Ref: " v-model="info" prepend-icon="create"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="warning" flat @click="toSref = false">Close</v-btn>
              <v-btn class="success" flat @click="addSRef">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Add Job Notes button and dialog -->
        <v-dialog v-model="toJobnote" max-width="600px">
          <template v-slot:activator="{ on }">
            <v-btn class="success mb-2 mx-1" v-on="on">Add Job Notes</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Set a Job Note</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field autofocus label="Job Note Title: " v-model="info" prepend-icon="create"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea label="Extra info: " v-model="info2" prepend-icon="create"></v-textarea>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="toJobnote = false">Close</v-btn>
              <v-btn color="blue darken-1" flat @click="addNotes">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Yellow Buttons -->
        <v-btn class="warning mb-2 mx-1" @click="$router.push('dash')"> Admin Dash</v-btn>
        <v-btn class="warning mb-2 mx-1" @click="withdraw" :loading="loading"> Withdraw from Factory</v-btn>
        <v-btn class="warning mb-2 mx-1" @click="pause" :loading="loading"> On Hold</v-btn>
        <v-btn class="warning mb-2 mx-1" @click="unpause" :loading="loading"> Off Hold</v-btn>
        <v-btn class="warning mb-2 mx-1" @click="delivered" :loading="loading"> Delivered</v-btn>
        <!-- Spacer -->
        <v-spacer></v-spacer>
        <!-- Search Field -->
        <v-text-field dark v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
      </v-card-title>
      <!-- Main CRUD data table -->
      <v-data-table dense :headers="headers" :items="orders" sort-by="name" :search="search" v-model="selected" item-key="worknum" show-select>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            edit
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            delete
          </v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <!-- End of CRUD table -->
    </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import moment from 'moment'
import db from '@/fb'
import firebase from 'firebase'
import Toolbar from '@/components/Toolbar'
import Navbar from '@/components/Navbar'
import Popup from '@/components/Popup'
export default {
  components: {
    Toolbar,
    Popup,
    Navbar
  },
  data: () => ({
    isMobile: false,
    dialog: false,
    addUser: false,
    toFactory: false,
    toInvoice: false,
    toDeliver: false,
    toSref: false,
    toJobnote: false,
    loading: false,

    items: [
      'Doors',
      'Frame',
      'Timber Section',
      'Screens',
      'Glass',
      'Iron Mongory'
    ],
    search: '',
    worknum: '',
    info: '',
    info2: '',
    customer: '',
    deliverydate: '',
    contract: '',
    product: '',
    select: '',
    code: '',
    qty: 0,
    factory: false,
    fsc: '',
    date: '',

    orders: [],
    selected: [],
    list: [],
    headers: [{
        text: 'Work #',
        align: 'left',
        value: 'worknum'
      },
      {
        text: 'Customer',
        align: 'center',
        value: 'customer'
      },
      {
        text: 'Date',
        align: 'center',
        value: 'date'
      },
      {
        text: 'Product',
        align: 'center',
        value: 'product'
      },
      {
        text: 'Status',
        align: 'center',
        value: 'status',
        sortable: false
      },
      {
        text: 'Invoice #',
        align: 'center',
        value: 'invoiceNum',
        sortable: false
      },
      {
        text: 'DeliveryNote #',
        align: 'center',
        value: 'deliveryNum',
        sortable: false
      },
      {
        text: 'Schedule Ref',
        align: 'center',
        value: 'sRef',
        sortable: false
      },
      {
        text: 'Job Notes',
        align: 'center',
        value: 'jobNotes',
        sortable: false
      }

    ],
    status: null,
    saw: null,
    lip: null,
    press: null,
    cnc: null,
    mach: null,
    mill: null,
    bench: null,
    spray: null,

    editedIndex: -1,
    editedItem: {
      worknum: '',
      customer: '',
      contract: '',
      ordernum: '',
      product: '',
      fsc: '',
      date: ''
    },
    defaultItem: {
      worknum: '',
      customer: '',
      contract: '',
      ordernum: '',
      product: '',
      fsc: '',
      date: ''
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },

    /*edit(){
       this.orders = this.$store.getters.rod
      return this.orders
    },
     userRoles () {
        return this.$store.getters.roles
      },*/


  },

  mounted() {
    console.log('App mounted!');
    // this.$store.dispatch('fetchRod')
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    db.collection('orders').onSnapshot(res => {
      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === 'added') {
          this.orders.push({
            ...change.doc.data(),
            id: change.doc.id
          })

        }
      })
    })
  },

  methods: {

    addSRef() {

      for (var i = 0; i < this.selected.length; i++) {

        var uname = firebase.auth().currentUser.email.split('@')[0]
        this.selected[i].sRef = this.info
        db.collection('orders').doc(this.selected[i].id).update({
          sRef: this.info,
          sRefname: uname,
          sReftime: moment(new Date()).format('YYYY-MM-DD HH:mm')

        }).then(() => {
          this.$emit('invoice')
          this.$router.replace('edit')
        })

      }
      this.selected = []
      toSref = false
      this.info = ''

    },
    addNotes() {

      for (var i = 0; i < this.selected.length; i++) {

        var uname = firebase.auth().currentUser.email.split('@')[0]
        this.selected[i].jobNotes = this.info
        db.collection('orders').doc(this.selected[i].id).update({
          jobNotes: this.info,
          extra: this.info2,
          jobNotesuname: uname,
          jobNotestime: moment(new Date()).format('YYYY-MM-DD HH:mm')
        }).then(() => {
          this.$emit('invoice')
          this.$router.replace('edit')

        })

      }
      this.selected = []
      this.toJobnote = false
      this.info = ''
      this.info2 = ''

    },
    addDeliveryNum() {

      for (var i = 0; i < this.selected.length; i++) {

        var uname = firebase.auth().currentUser.email.split('@')[0]
        this.selected[i].deliveryNum = this.info.toString()
        db.collection('orders').doc(this.selected[i].id).update({
          deliveryNum: this.info,
          deliveryNumName: uname,
          deliveryNumTime: moment(new Date()).format('YYYY-MM-DD HH:mm')
        }).then(() => {
          this.$emit('invoice')
          this.$router.replace('edit')
        })


      }
      this.selected = []
      this.info = ''
      this.toDeliver = false

    },
    addInvoice() {
      var uname = firebase.auth().currentUser.email.split('@')[0]
      for (var i = 0; i < this.selected.length; i++) {
        this.selected[i].invoiceNum = this.info.toString()
        db.collection('orders').doc(this.selected[i].id).update({
          invoiceNum: this.info,
          invoicedBy: uname,
          invoicedTime: moment(new Date()).format('YYYY-MM-DD HH:mm')

        }).then(() => {
          this.$emit('invoice')
          this.$router.replace('edit')

        })

      }
      this.selected = []
      toInvoice = false
      this.info = ''

    },
    delivered() {
      var uname = firebase.auth().currentUser.email.split('@')[0]
      for (var i = 0; i < this.selected.length; i++) {
        this.selected[i].status = 'Delivered'
        console.log(this.selected[i].status)
        db.collection('orders').doc(this.selected[i].id).update({
          status: 'Delivered',
          statusuname: uname,
          statustime: moment(new Date()).format('YYYY-MM-DD HH:mm')
        }).then(() => {
          this.$emit('Delivered')
          this.$router.replace('edit')
        })

      }

    },
    start() {

      for (var i = 0; i < this.selected.length; i++) {
        this.selected[i].status = 'To Factory'
        console.log(this.selected[i].status)
        var uname = firebase.auth().currentUser.email.split('@')[0]
        db.collection('orders').doc(this.selected[i].id).update({
          status: 'To Factory',
          toFactory: true,
          toFactoryby: uname,
          toFactoryat: moment(new Date()).format('YYYY-MM-DD HH:mm'),
          deliverydate: moment(this.deliverydate).format('W'),


        }).then(() => {
          this.$emit('In Factory')
          this.$router.replace('edit')
        })

      }
      this.toFactory = false

    },
    changeProduct() {
      if (this.editedIndex > -1) {
        Object.assign(this.orders[this.editedIndex], this.editedItem)


      } else {
        this.orders.push(this.editedItem)
      }
      var eobjects
      var esteps
      confirm('Are you sure you want to change product? Steps will have to be re-entered')
      switch (this.editedItem.product) {
        case 'Doors':
          esteps = {
            factory: false,
            saw: false,
            lip: false,
            press: false,
            cnc: false,
            bench: false,
            spray: false
          }
          eobjects = {
            "A-factory": {
              state: false,
              user: '',
              timestamp: ''
            },
            "B-saw": {
              state: false,
              user: '',
              timestamp: ''
            },
            "C-lip": {
              state: false,
              user: '',
              timestamp: ''
            },
            "F-press": {
              state: false,
              user: '',
              timestamp: ''
            },
            "G-cnc": {
              state: false,
              user: '',
              timestamp: ''
            },
            "H-bench": {
              state: false,
              user: '',
              timestamp: ''
            },
            "I-spray": {
              state: false,
              user: '',
              timestamp: ''
            }
          }
          break;
        case 'Frame':
          esteps = {
            factory: true,
            mach: false,
            mill: false,
            bench: false,
            spray: false,
            cnc: false
          }
          eobjects = {
            "A-factory": {
              state: false,
              user: '',
              timestamp: ''
            },
            "D-mach": {
              state: false,
              user: '',
              timestamp: ''
            },
            "E-mill": {
              state: false,
              user: '',
              timestamp: ''
            },
            "F-press": {
              state: false,
              user: '',
              timestamp: ''
            },
            "G-cnc": {
              state: false,
              user: '',
              timestamp: ''
            },
            "H-bench": {
              state: false,
              user: '',
              timestamp: ''
            },
            "I-spray": {
              state: false,
              user: '',
              timestamp: ''
            }
          }
          break;
        case 'Timber Section':
          esteps = {
            factory: true,
            bench: false,
            spray: false
          }
          eobjects = {
            "A-factory": {
              state: true,
              user: '',
              timestamp: ''
            },
            "H-bench": {
              state: false,
              user: '',
              timestamp: ''
            },
            "I-spray": {
              state: false,
              user: '',
              timestamp: ''
            }
          }
          break;
        case 'Screens':
          esteps = {
            factory: true,
            bench: false,
            spray: false
          }
          eobjects = {
            "A-factory": {
              state: true,
              user: '',
              timestamp: ''
            },
            "H-bench": {
              state: false,
              user: '',
              timestamp: ''
            },
            "I-spray": {
              state: false,
              user: '',
              timestamp: ''
            }
          }
          break;
        case 'Glass':
          esteps = {
            factory: true,
            bench: false,
            spray: false
          }
          eobjects = {
            "A-factory": {
              state: true,
              user: '',
              timestamp: ''
            },
            "H-bench": {
              state: false,
              user: '',
              timestamp: ''
            },
            "I-spray": {
              state: false,
              user: '',
              timestamp: ''
            }
          }
          break;
        case 'Ironmongory':
          esteps = {
            factory: true,
            bench: false,
            spray: false
          }
          eobjects = {
            "A-factory": {
              state: true,
              user: '',
              timestamp: ''
            },
            "H-bench": {
              state: false,
              user: '',
              timestamp: ''
            },
            "I-spray": {
              state: false,
              user: '',
              timestamp: ''
            }
          }
          break;
      }
      this.close()
      db.collection('orders').doc(this.orders[this.editedIndex].id).update({
        product: this.editedItem.product,
        steps: esteps,
        objects: eobjects,
      })
    },
    save() {
      //console.log(this.editedItem.id)
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          Object.assign(this.orders[this.editedIndex], this.editedItem)


        } else {
          this.orders.push(this.editedItem)

        }
        // var eobjects
        // var esteps

        this.close()
        if (this.editedItem.newNotes == undefined) this.editedItem.newNotes = "_"
        if (this.editedItem.postcode == undefined) this.editedItem.postcode = "_"
        if (this.editedItem.finish == undefined) this.editedItem.finish = "_"
        if (this.editedItem.delivery == undefined) this.editedItem.delivery = "_"
        db.collection('orders').doc(this.orders[this.editedIndex].id).update({

          deliverydate: this.editedItem.deliverydate,
          notes: this.editedItem.newNotes,
          notes2: this.editedItem.notes2,
          qty: this.editedItem.qty,
          postcode: this.editedItem.postcode,
          location: this.editedItem.location,
          delivery: this.editedItem.delivery,
          // product: this.editedItem.product,
          // steps: esteps,
          // objects: eobjects,
          finish: this.editedItem.finish,
        })
        /*.then(()=>{

                  })*/
      }


    },
    unpause() {
      var uname = firebase.auth().currentUser.email.split('@')[0]
      for (var i = 0; i < this.selected.length; i++) {
        this.selected[i].status = 'In Factory'
        console.log(this.selected[i].status)
        db.collection('orders').doc(this.selected[i].id).update({
          status: 'In Factory',
          withdrawn: false,
          "objects.A-factory.state": true,
          "objects.A-factory.user": uname,
          "objects.A-factory.timestamp": moment(new Date()).format('YYYY-MM-DD HH:mm')
        }).then(() => {
          this.$emit('on Hold')
          this.$router.replace('edit')
        })

      }

    },
    withdraw() {
      var uname = firebase.auth().currentUser.email.split('@')[0]
      for (var i = 0; i < this.selected.length; i++) {
        this.selected[i].status = 'Withdrawn'
        console.log(this.selected[i].status)
        db.collection('orders').doc(this.selected[i].id).update({
          status: 'Withdrawn',
          withdrawn: true,
          withdrawby: uname,
          withdrawat: moment(new Date()).format('YYYY-MM-DD HH:mm')
        }).then(() => {
          this.$router.replace('edit')
        })

      }

    },
    pause() {
      var uname = firebase.auth().currentUser.email.split('@')[0]
      for (var i = 0; i < this.selected.length; i++) {
        this.selected[i].status = 'ON HOLD'
        console.log(this.selected[i].status)
        db.collection('orders').doc(this.selected[i].id).update({
          status: 'ON HOLD',
          heldby: uname,
          heldat: moment(new Date()).format('YYYY-MM-DD HH:mm')
        }).then(() => {
          this.$emit('on Hold')
          this.$router.replace('edit')
        })

      }

    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.orders.slice()
    },
    editItem(item) {
      this.editedIndex = this.orders.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem(item) {
      const index = this.orders.indexOf(item)
      confirm('Are you sure you want to delete this item?') && this.orders.splice(index, 1)
      db.collection('orders').doc(item.id).delete({}).then(() => {
        this.$emit('Cancelled')
      })
    },

    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.orders[this.editedIndex], this.editedItem)
      } else {
        this.orders.push(this.editedItem)
      }
      this.close()
    }
  }
}
</script>
<style>
#test {
  margin-top: 5%
}

table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 7px;
}

.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid deeppink;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid cyan;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: .5em;
    text-align: left;
    display: block;
    color: #999;

  }

  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }

  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }

}

.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;
  width: 50%;
  height: 40px;
  font-weight: bold;
}
</style>
